export { StatementFigure, type StatementFigureProps } from "./StatementFigure"
